import React, { Component } from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import InternalLinks from "./internal_links";
import ExternalLinks from "./external_links";
import "./App.css";
import { data } from "./project-details";

var slideLeft = () => {
  var slider = document.getElementById('slider')
  slider.scrollLeft = slider.scrollLeft - 500
}

var slideRight = () => {
  var slider = document.getElementById('slider')
  slider.scrollLeft = slider.scrollLeft + 500
}

class Projects extends Component {

  render() {
    return (
        <div style={{"margin":"50px 0px 50px", "textAlign": "center"}} id="/projects">

          <InternalLinks />
          <br />
          <ExternalLinks />

          <br /><br /><br />
            
            <div className="reveal">
              <MdChevronLeft className='toggle-projects' onClick={slideLeft} size={40} />
              <MdChevronRight className='toggle-projects' onClick={slideRight} size={40} />
            </div>
            <div id='slider' className="allprojects reveal">
              {data.map((item)=> ( item.proj ))}
            </div>

        </div>
    );
  }

}


export default Projects;